import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { Link } from "~/client/components/Link";
import { KibelaSymbol } from "~/client/components/shared/kibela_symbol";
import { Pagination } from "~/client/components/shared/pagination";
import { Timestamp } from "~/client/components/shared/Timestamp";
import { UserAvatarWithPopup } from "~/client/components/shared/UserAvatarWithPopup";
import type { CreateCustomEmojiMutation } from "~/client/generated/schema";

type CustomEmoji = CreateCustomEmojiMutation["createCustomEmoji"]["customEmoji"];

interface Props {
  intl: any;
  customEmojis: Array<CustomEmoji>;

  onClickDelete(customEmojiId);
}

const listLength = 20;

export const CustomEmojiList: React.FC<Props> = (props) => {
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [searchText, setSearchText] = useState<string>("");

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(0);
  };

  const searchResults = props.customEmojis.filter((customEmoji) => customEmoji.emojiCode.includes(searchText));
  const pageResults = searchResults.slice(currentPage * listLength, (currentPage + 1) * listLength);

  return (
    <div className="customEmojiList">
      <div className="searchBox">
        <input
          type="search"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={props.intl.formatMessage({ id: "customEmoji.searchPlaceHolder" })}
          value={searchText}
          onChange={handleChangeSearchText}
        />
        <KibelaSymbol id="search" />
      </div>

      <table className="customEmojiList-list">
        <thead>
          <tr className="customEmojiList-listHeader">
            <th className="customEmojiList-cell--emoji" />
            <th className="customEmojiList-cell--code">
              <FormattedMessage id="customEmoji.code" />
            </th>
            <th className="customEmojiList-cell--avatar">
              <FormattedMessage id="customEmoji.createUserAccount" />
            </th>
            <th className="customEmojiList-cell--date">
              <FormattedMessage id="customEmoji.createDate" />
            </th>
            <th className="customEmojiList-cell--actions" />
          </tr>
        </thead>
        <tbody>
          {pageResults.map((customEmoji) => (
            <tr key={`customEmojiListRow-${customEmoji.emojiCode}`} className="customEmojiList-listItem">
              <td className="customEmojiList-cell--emoji">
                <img className="emoji" src={customEmoji.imageUrl} />
              </td>
              <td className="customEmojiList-cell--code">{`:${customEmoji.emojiCode}:`}</td>
              <td className="customEmojiList-cell--avatar">
                <div className="userAvatar">
                  <UserAvatarWithPopup user={customEmoji.createUser} size={"small"} />
                  <Link className="account" to={customEmoji.createUser.path!}>
                    {customEmoji.createUser.account}
                  </Link>
                </div>
              </td>
              <td className="customEmojiList-cell--date">
                <Timestamp value={customEmoji.createdAt} />
              </td>
              <td className="customEmojiList-cell--actions">
                <span onClick={() => props.onClickDelete(customEmoji.id)}>
                  <KibelaSymbol id="delete" />
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        totalPages={Math.ceil(searchResults.length / listLength)}
        currentPage={currentPage}
        onPageChange={({ selected }) => setCurrentPage(selected)}
      />
    </div>
  );
};
